import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

interface ArrowLeftIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const ArrowLeftIcon = ({ color = 'currentColor', width = 23, height = 18, className, ...props }: ArrowLeftIconProps) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();

    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 23 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M9.22203 1.24985L1.25 8.55754L9.22203 15.8652"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M21.3896 8.55664H1.38965" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
};

export default ArrowLeftIcon;
